import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import Out from "./Out";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CustomizedProgressBars from "./spinner";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import IconButton from "@material-ui/core/IconButton";
import * as handler from "../Actions/main";
class Outlets extends Component {
  flag = 0;
  componentWillMount() {
    console.log("outletMount");
    this.props.resetMenu();
  }
  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    // if(parsed.pnr && this.props.status !== true)
    // { this.props.isLoader();

    // }
    if (parsed.pnr) {
      console.log(this.props.pnr);
      if (this.props.status !== true || this.props.pnr !== parsed.pnr) {
        console.log("insidepnr");
        console.log(parsed.pnr);

        this.props.fetchByPnr(parsed.pnr);
      }
    } else if (parsed.doj && parsed.trainNO && parsed.stationCode) {
      let y = parsed.trainNO.split("/ ");
      console.log(y[1]);
      if (this.props.status !== true) {
        this.props.fetchOutlets(y[0], parsed.doj, parsed.stationCode, y[1], "");
      }
    } else {
      this.props.reset();
      console.log("url is not correct");
    }
  }
  back = () => {
    //this.props.statusChange();
    this.props.reset();
    this.props.history.goBack();
  };

  render() {
    // const { isLoading } = this.state;
    let out = [];
    // const parsed = queryString.parse(this.props.location.search);

    if (this.props.isLoading === false && this.props.outl !== null) {
      out = this.props.outl
        .map((outlet, index) => {
          if (outlet.outlets.length > 0) {
            this.flag = 1;
            console.log(this.flag);
            return (
              <Out
                statC={outlet.stationCode}
                statN={outlet.stationName}
                sch={outlet.ArrivalTime}
                day={outlet.Day}
                OUTLETS={outlet.outlets}
                trainNo={this.props.trainNO}
                trainN={this.props.trainName}
                doj={this.props.doj}
                key={index}
              />
            );
          } else return null;
        })
        .filter(e => {
          if (e !== "") return true;
          else return false;
        });
    } else this.flag = 0;
    let x;
    if (this.props.isLoading === false) {
      if (this.props.error === false && this.flag === 1) {
        x = (
          <Fragment>
            <Grid
              container
              alignItems="center"
              spacing={1}
              style={{
                backgroundColor: "#45A04A",
                position: "fixed",
                top: 0,
                zIndex: 100
              }}
            >
              <Grid item xs={2} style={{ marginLeft: "10px" }}>
                <IconButton
                  edge="start"
                  style={{ color: "white" }}
                  onClick={this.back}
                  aria-label="Close"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
                Available Restaurants
              </Grid>
            </Grid>
            <Container>
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "60px"
                }}
              >
                {out}
              </Grid>
            </Container>
          </Fragment>
        );
      } else if (this.props.error === false && this.flag === 0)
        x = (
          <Container style={{ marginTop: "50%", textAlign: "center" }}>
            <span style={{ fontSize: "14px" }}> No Restaurant found </span>
          </Container>
        );
      else if (this.props.error === true)
        x = (
          <Container style={{ marginTop: "50%", textAlign: "center" }}>
            <span style={{ fontSize: "14px" }}> Failed while fetching </span>
          </Container>
        );
    } else {
      x = (
        <Container>
          <Typography
            color="textSecondary"
            align="center"
            style={{ marginBottom: 150 }}
          />
          <div style={{ textAlign: "center", marginBottom: 5 }}>
            <CustomizedProgressBars />
          </div>
          <Typography variant="h5" color="textSecondary" align="center">
            Fetching Restaurants
          </Typography>
        </Container>
      );
    }

    return x;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchOutlets: (trainNO, doj, stationCode, trainName, pnr) =>
      dispatch(handler.initOutlets(trainNO, doj, stationCode, trainName, pnr)),
    reset: () => dispatch(handler.resetOutlets()),
    resetMenu: () => dispatch(handler.reset()),
    fetchByPnr: pnr => dispatch(handler.initByPnr(pnr))
    // notLoading: () => dispatch(handler.notLoading())
  };
};

const mapStateToProps = state => {
  return {
    isLoading: state.outletR.isLoadingO,
    outl: state.outletR.allOutlets,
    error: state.outletR.errorO,
    status: state.outletR.status,
    trainNO: state.outletR.trainNO,
    trainName: state.outletR.trainName,
    doj: state.outletR.doj,
    pnr: state.outletR.pnr
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Outlets);
